import { GenericStatus } from "./props";

const VesselRequisitionItemApprovalStatus: GenericStatus[] = [
    {key: "pending", text: "Pending", tagVariant: 'warning', isDefault: true},
    {key: "approved", text: "Approved", tagVariant: 'active'},
    {key: "rejected", text: "Rejected", tagVariant: 'error'}
]                                                        

export default VesselRequisitionItemApprovalStatus;